<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Production Control Time" active>

                                <b-row v-if="hasFailedDataProductionControlTime">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedProductionControlTime.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionControlTimesFailed" :fields="fieldsProductionControlTime" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionControlTime" :sort-desc.sync="sortDescProductionControlTime" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedProductionControlTime.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionControlTimes" :fields="fieldsProductionControlTime" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionControlTime" :sort-desc.sync="sortDescProductionControlTime" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Production Control Time Detail" active>

                                <b-row v-if="hasFailedDataProductionControlTimeDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedProductionControlTimeDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionControlTimeDetailsFailed" :fields="fieldsProductionControlTimeDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionControlTimeDetail" :sort-desc.sync="sortDescProductionControlTimeDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedProductionControlTimeDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionControlTimeDetails" :fields="fieldsProductionControlTimeDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionControlTimeDetail" :sort-desc.sync="sortDescProductionControlTimeDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import ProductionControlTime from '@/models/ProductionControlTime/ProductionControlTime';
import ProductionControlTimeList from '@/models/ProductionControlTime/ProductionControlTimeList';
import ProductionControlTimeFilter from '@/filters/ProductionControlTime/ProductionControlTimeFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsProductionControlTime: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Production Control Time Name", key: 'name', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsProductionControlTimeDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Standar Time Name", key: 'standarTimeIdStandarTimeName', sortable: false},
				{"class" : "th-status", "label" : "Standar Time (Minutes)", key: 'standarTimeValue', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			productionControlTimes : [],
			productionControlTimesFailed: [],
			productionControlTimeId : '',
			sortByProductionControlTime: '',
			sortDescProductionControlTime: '',
			hasFailedDataProductionControlTime: false,
			totalFailedProductionControlTime: 0,
			totalSucceedProductionControlTime: 0,
			productionControlTimeDetails : [],
			productionControlTimeDetailsFailed: [],
			productionControlTimeDetailId : '',
			sortByProductionControlTimeDetail: '',
			sortDescProductionControlTimeDetail: '',
			hasFailedDataProductionControlTimeDetail: false,
			totalFailedProductionControlTimeDetail: 0,
			totalSucceedProductionControlTimeDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('productioncontroltime/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('productioncontroltime/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getProductionControlTimeForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getProductionControlTimeForUpload : async function() {
			let _this = this;
			this.$http.get('productioncontroltime/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.productionControlTimes = [];
_this.productionControlTimeDetails = [];


					if (response != null) {
						let result = response.data;
						_this.productionControlTimes = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedProductionControlTime = _this.productionControlTimes.length;

						_this.productionControlTimesFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataProductionControlTime = true;
						_this.totalFailedProductionControlTime = 0;
						if(_this.productionControlTimesFailed == undefined || _this.productionControlTimesFailed.length === 0) _this.hasFailedDataProductionControlTime = false;
						if(_this.hasFailedDataProductionControlTime) _this.totalFailedProductionControlTime = _this.productionControlTimesFailed.length;
						_this.productionControlTimeDetails = [];
						_this.productionControlTimeDetailsFailed = [];
						_this.hasFailedDataProductionControlTimeDetail = true;
						_this.totalSucceedProductionControlTimeDetail = 0;
						result.forEach(function(element) {
							_this.productionControlTimeDetails.push(...element.productionControlTimeDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedProductionControlTimeDetail = _this.productionControlTimeDetails.length;

							_this.productionControlTimeDetailsFailed.push(...element.productionControlTimeDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.productionControlTimeDetailsFailed == undefined || _this.productionControlTimeDetailsFailed.length === 0) _this.hasFailedDataProductionControlTimeDetail = false;
							if(_this.hasFailedDataProductionControlTimeDetail) _this.totalFailedProductionControlTimeDetail = _this.productionControlTimeDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'productioncontroltime/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'ProductionControlTime.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterProductionControlTime = new ProductionControlTimeFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
